import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Snackbar,
} from "@material-ui/core";
import { Alert } from "@mui/material";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { unlinkCategoryAction } from "../../../redux/coupon/unLinkCategoryRTK";

export default function UnLinkCategory({
  unlinkCategory,
  setUnLinkCategory,
  propsData,
}) {
  // state---->

  const dispatchRTK = useDispatch();
  const unlinkCategorySelector = useSelector((state) => state.unlinkCategory);
  const { data, status, message, error } = unlinkCategorySelector;
  const [snackbarState, setSnackbarState] = useState(false)
  // function -->

  const handleClose = () => {
    setUnLinkCategory(false);
  };

  const unlinkCategoryFunc = () => {
    dispatchRTK(unlinkCategoryAction(propsData));
    if (data?.status_code == 200) {
      setUnLinkCategory(false);
    }
    setSnackbarState(true)
  };

  const snackBarClose = () => {
    setSnackbarState(false)
    setUnLinkCategory(false)
  }

  return (
    <>
      <Dialog
        open={unlinkCategory}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        {propsData?.catId == "" || propsData?.catId == undefined ? (
          <>
            <DialogTitle id="alert-dialog-title">Un-link Category</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                Sorry you are not linked with any Category
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose}>Close</Button>
            </DialogActions>
          </>
        ) : (
          <>
            <DialogTitle id="alert-dialog-title">Un-link Category</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                Are you sure you want to un-link your Category ?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={unlinkCategoryFunc} autoFocus>
                Agree
              </Button>
              <Button onClick={handleClose}>Close</Button>
            </DialogActions>
          </>
        )}
      </Dialog>


      {/* snackbar */}
      <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={snackbarState} autoHideDuration={1000} onClose={snackBarClose}>
        <Alert onClose={snackBarClose} severity={status == 200 ? "success" : "error"} sx={{ width: '100%' }}>
          {message}
        </Alert>
      </Snackbar>
    </>
  );
}
